import GeoscapeDeveloperSvg from "icons/hub-logo-footbar.svg?react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { useTheme, Link } from "@mui/material";

const pages = [
  {
    name: "PRIVACY POLICY",
    link: "https://geoscape.com.au/legal/privacy-policy",
  },
  {
    name: "TERMS",
    link: "/settings/user/legal",
  },
];

const pages2 = [
  {
    name: "SERVICE STATUS",
    link: "https://status.geoscape.com.au/",
  },
  {
    name: "API DOCS",
    link: "https://api-docs.geoscape.com.au",
  },
];

const ResponsiveAppBar = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <AppBar
      position="static"
      color="inherit"
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Container
        maxWidth={false}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ display: "flex", gap: "16px" }}>
          {pages.map((page, index) => (
            <Button
              key={page.name}
              target={page.name === "TERMS" ? "" : "_blank"}
              component={page.name === "TERMS" ? Link : "a"}
              // target="_blank"
              href={page.link}
              sx={{
                color: "text.secondary",
                display: "block",
              }}
            >
              {page.name}
            </Button>
          ))}
        </Box>

        <Box style={{ display: "flex" }}>
          <GeoscapeDeveloperSvg
            fill={isDark ? "white" : "black"}
            height={"35px"}
          />
        </Box>

        <Box style={{ display: "flex", gap: "16px" }}>
          {pages2.map((page, index) => (
            <Button
              key={page.name}
              target="_blank"
              href={page.link}
              sx={{
                color: "text.secondary",
                display: "block",
              }}
            >
              {page.name}
            </Button>
          ))}
        </Box>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
